import { FC } from "react";
import { Box, Divider, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import formatDayLabel from "src/utils/Company/Absences/formatDayLabel";

interface IBalanceStatusBadgePreviewProps {
  labelUT: string;
  color: string;
}

const BalanceStatusBadgePreview: FC<IBalanceStatusBadgePreviewProps> = ({
  labelUT,
  color,
}) => (
  <Box
    sx={{
      background: "white",
      padding: "0.5rem 1rem",
      borderRadius: "0.25rem",
      inlineSize: "fit-content",
    }}
    data-testId="absence-balance-status"
  >
    <Typography variant="subtitle2" component="span">
      {__(labelUT)}:{" "}
    </Typography>
    <Typography
      variant="subtitle2"
      color={color}
      component="span"
      data-testId="absence-balance-status__count"
    >
      {__("wartość zmienna")}
    </Typography>
    <>
      <Divider sx={{ m: "0.5rem 0 0" }} />
      <Typography variant="caption">{__("W tym zaległe")}:</Typography>
      <Typography variant="subtitle2" color="info.dark">
        {__("wartość zmienna")}
      </Typography>
    </>
  </Box>
);

export default BalanceStatusBadgePreview;
